import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { IRectangle } from 'ngx-mat-esign360';

@Component({
  selector: 'lib-document-field',
  templateUrl: './document-field.component.html',
  styleUrls: ['./document-field.component.scss'],
})
export class DocumentFieldComponent implements OnInit {
  @Input() boundingBox: IRectangle;
  @HostBinding('style.left.pt') get leftPt() {
    return this.boundingBox?.x;
  }
  @HostBinding('style.top.pt') get topPt() {
    return this.boundingBox?.y;
  }
  @HostBinding('style.width.pt') get widthPt() {
    return this.boundingBox?.width;
  }
  @HostBinding('style.height.pt') get heightPt() {
    return this.boundingBox?.height;
  }

  constructor() {}

  ngOnInit(): void {}
}
